import {
  RouterProvider,
  createBrowserRouter
} from "react-router-dom";
import ThemeCustomization from "./themes";
import ScrollTop from "./components/ScrollTop";
import { ToastContainer } from "react-toastify";
import { bounce } from "./pages/TosterAlert";
import axios from "axios";
import { getCookie } from "./helpers/cookie";
import { handleAuthentication, resetDataAndLogout } from "./helpers/auth";
import LoginRoutes from "./routes/LoginRoutes";
import MainRoutes from "./routes/MainRoutes";
import { useSelector } from "react-redux";
import "./App.css";
import { useEffect } from "react";
import SessionManager from "./auth/SessionManager";




const skipAuthRoutes = [
  "login",
  "refreshToken",
  "OTPValidation",
  "registration",
  "registerLogin",
];
const skipEmpanelRegistration = ["OTPValidation", "registration","/registration/existingRegistration"];

axios.interceptors.request.use(
  function (config) {
    const skipCheckRegister = skipEmpanelRegistration.some((route) =>
      config.url.includes(route)
    );

    const skipCheck = skipAuthRoutes.some((route) =>
      config.url.includes(route)
    );

    // if (!skipCheck && window.location.pathname !== "/registration") {
    //   const headerToken = `Bearer ${getCookie("accessToken")}`;

    //   config.headers.Authorization = headerToken;
    // } else if (window.location.pathname == "/registration" && !skipCheck) {
    //   const headerToken = `Bearer ${getCookie("registerNewAccessToken")}`;
    //   config.headers.Authorization = headerToken;
    // } else {
    //   resetDataAndLogout();
    // }

    const path = window.location.pathname;
const regPaths = ["/registration", "/registration/existingRegistration"];

if (!skipCheck && !regPaths.includes(path)) {
  config.headers.Authorization = `Bearer ${getCookie("accessToken")}`;
} else if (!skipCheck && regPaths.includes(path)) {
  config.headers.Authorization = `Bearer ${getCookie("registerNewAccessToken")}`;
} else {
  resetDataAndLogout();
}

    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
  

    if (error?.response?.status == 401) {
      if (error?.config?.url.includes("refreshToken")) {
        window.location.href = "/";
        resetDataAndLogout();							 
      }
      return handleAuthentication(error);
    }
    return Promise.reject(error);
  }
);

// ==============================|| APP - THEME, ROUTER, LOCAL ||============================== //

export default function App() {
  const login = useSelector((state) => state?.login || []);

  const isLogggedIn = getCookie("accessToken");

  const routes = [LoginRoutes];

  if (isLogggedIn || login) {
    routes.push(MainRoutes);
  }


const router = createBrowserRouter(routes, {
  basename: "/",
  future: {
   v7_startTransition: true,
  }
});

useEffect(()=>{
if(!isLogggedIn){
  window.location.path='/';
}
},[!isLogggedIn])
  

  

  return (
    <ThemeCustomization>
      <ScrollTop>
        <ToastContainer transition={bounce} />
        {/* <SessionTimeoutHandler /> */}
        <SessionManager children={  <RouterProvider router={router} />}
        
        />
      </ScrollTop>
      <style
        dangerouslySetInnerHTML={{
          __html: `
          input[type="password"]::-ms-reveal,
          input[type="password"]::-ms-clear {
            display: none !important;
          }
        `,
        }}
      />
    </ThemeCustomization>
  );
}
